import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const shuffle = (a) => {
  const b = [...a];
  for (let i = b.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [b[i], b[j]] = [b[j], b[i]];
  }
  return b;
};

const Cup = ({ lifted, highlight }) => (
  <motion.div animate={{ y: lifted ? -70 : 0 }} transition={{ type: "spring", stiffness: 180, damping: 14 }}
    className="relative z-10 w-20 h-24 sm:w-28 sm:h-32">
    <div className={`absolute inset-0 [clip-path:polygon(18%_0,82%_0,100%_100%,0_100%)] rounded-t-xl ${highlight ? "bg-gradient-to-b from-[#F5E9C2] to-[#A8841A]" : "bg-gradient-to-b from-[#E8C766] to-[#866812]"}`} />
    <div className="absolute top-3 left-1/2 -translate-x-1/2 w-1/2 h-1.5 rounded-full bg-white/30" />
    <div className="absolute -bottom-1 left-0 right-0 h-3 rounded-full bg-[#644D0D]" />
  </motion.div>
);

export const CupsBoard = ({ phase, picked, winning, onPick }) => {
  const [order, setOrder] = useState([0, 1, 2]);
  useEffect(() => {
    if (phase !== "shuffling") { return undefined; }
    const id = setInterval(() => setOrder((o) => shuffle(o)), 320);
    return () => { clearInterval(id); setOrder([0, 1, 2]); };
  }, [phase]);
  const revealed = phase === "revealed";
  return (
    <div className="flex items-end justify-center gap-4 sm:gap-10 h-56 sm:h-64 pt-16" data-testid="cups-board">
      {order.map((key, pos) => {
        const isWin = revealed && winning === pos;
        const lifted = revealed && (picked === pos || winning === pos);
        return (
          <motion.button layout key={key} type="button" disabled={phase !== "picking"} onClick={() => onPick(pos)}
            className={`relative flex flex-col items-center rounded-2xl p-2 transition-shadow ${phase === "picking" ? "cursor-pointer hover:shadow-[0_0_30px_rgba(201,162,39,0.55)]" : "cursor-default"} ${picked === pos && revealed ? "ring-2 ring-yellow-400/70" : ""}`}
            data-testid={`cup-${pos}`}>
            <Cup lifted={lifted} highlight={phase === "picking"} />
            <div className="h-8 flex items-center justify-center -mt-6">
              {isWin && <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} className="w-7 h-7 rounded-full bg-gradient-to-br from-[#FFFFFF] to-[#E8C766] shadow-[0_0_18px_rgba(232,199,102,0.9)]" data-testid="cups-ball" />}
            </div>
            <span className="text-xs text-gray-500 mt-1">Cup {pos + 1}</span>
          </motion.button>
        );
      })}
    </div>
  );
};
